import { AuditService } from '../../audit.service';
import { Component, OnInit, EventEmitter } from '@angular/core';
import { DISPLAY_DATE_FORMAT } from '../../../app.constants';
import { BreadcrumbItem, TableData, RequestResult, TableOptions } from '../../../shared/shared.model';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { Audit, Capa, CapaECTypes, CapaStatus, Evidence, TableDataEvidence } from '../../audit.model';
import { FindingService } from '../../finding.service';
import { CapaService } from '../../capa.service';
import { filter, switchMap, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { CapaEditDialogComponent } from '../capa-edit-dialog/capa-edit-dialog.component';
import { SidService } from '../../sid.service';
import { Sid } from '../../sid.model';
import { EvidenceService } from '../../evidence.service';
import { EvidenceAddDialogComponent } from '../../evidence/evidence-add-dialog/evidence-add-dialog.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'iaud-capa-detail',
  templateUrl: './capa-detail.component.html',
  styleUrls: ['./capa-detail.component.scss']
})
export class CapaDetailComponent implements OnInit {

  Capa: Capa;
  dateFormat: string = DISPLAY_DATE_FORMAT;

  breadcrumbs: Array<BreadcrumbItem> = [
    {
      title: 'Home',
      path: '/home',
    }
  ];
  auditId: number;
  findingId: number;
  sidId: number;
  capaId: number;
  capa: Capa;
  audit: Audit;
  sid: Sid;
  capaTypes = CapaECTypes;
  capaType: string;
  capaStatus = CapaStatus;
  canUpdate  : boolean;
  hasHistory : boolean;
  isApproved : boolean;
  evidenceTableData: TableData<Evidence>;
  hasInitialEvidences: boolean = false;
  canAddEvidence: boolean;
  forceReloadEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  evidenceTableOptions: TableOptions = {
    actionButtons: false,
    hideDeleteButton:false,
    columns: [
      {
        title: 'Status',
        fieldName: 'status',
      },
      {
        title: 'Reason',
        fieldName: 'reason',
      },
      {
        title: 'Evidence ID',
        fieldName: 'evidenceId',
      },
      {
        title: 'Evidence File',
        fieldName: 'fileName',
      },
      {
        title: 'Created By',
        fieldName: 'createdBy',
      },
      {
        title: 'Created Date',
        fieldName: 'createdOn',
        pipe: new DatePipe('en-US'),
        pipeParams: DISPLAY_DATE_FORMAT,
      },
      {
        title: 'Updated By',
        fieldName: 'modifiedBy',
      },
      {
        title: 'Updated Date',
        fieldName: 'modifiedOn',
        pipe: new DatePipe('en-US'),
        pipeParams: DISPLAY_DATE_FORMAT,
      },
    ],
    additionalInfo: [
      {
        title: 'Evidence Description',
        fieldName: 'description',
      },
      {
        title: 'Status',
        fieldName: 'status',
      },
      {
        title: 'Reason',
        fieldName: 'reason',
      },
    ],
  };
  
  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private auditService: AuditService,
    private findingService: FindingService,
    private capaService: CapaService,
    private sidService: SidService,
    private evidenceService: EvidenceService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.route.paramMap.pipe(
      
      switchMap((params: ParamMap): Observable<Capa> => {
        this.auditId = +params.get('auditId');
        this.sidId = +params.get('sidId');
        if (this.auditId > 0) {
          let b = {
            title: 'Audit:',
            path: `/audit/${this.auditId}`
          };
          this.breadcrumbs.push(
            {
              title: 'All audits',
              path: '/audit',
            });
          this.breadcrumbs.push(b);
          this.auditService.getAudit(this.auditId)
            .subscribe(a => {
              this.audit = a;
              b.title = `Audit: ${a.auditTitle}`;
            });
        } else if (this.sidId) {
          this.breadcrumbs = [
            {
              title: 'All SIDs',
              path: '/sid/list',
            }
          ];
          const sid = {
            title: `SID: `,
            path: `/sid/${this.sidId}`,
          };
          this.breadcrumbs.push(sid);

          this.sidService.get(this.sidId)
            .subscribe(x => {
              this.sid = x;
              sid.title = `SID: ${x.title}`;
            });
        } else {
          this.breadcrumbs.push(
            {
              title: 'All Capa',
              path: '/audit/all/capa',
            });
        }
        this.findingId = +params.get('findingId');

        if (this.findingId) {
          const f = {
            title: 'Finding:',
            path: `/audit/${this.auditId}/finding/${this.findingId}`,
          };
          this.breadcrumbs.push(f);
          this.findingService.getFinding(this.findingId, this.auditId)
            .subscribe(x => f.title = `Finding: ${x.findingTitle}`);
        }

        this.capaId = +params.get('capaId');

        this.reloadEvidenceList()
        .subscribe(table => {
          this.evidenceTableData = table;
          this.hasInitialEvidences = table.items.length > 0;
        });

        this.forceReloadEvent.emit(true);
        
        return this.capaService.getCapa(this.capaId);
      })
    )
      .subscribe(v => {
        this.capa = v;

        this.canUpdate = true;
        this.hasHistory = (this.capa.history=="" || this.capa.history==null)? false:true;  

        this.isApproved = false;
        if(this.capa.status.toLowerCase() == "approved"){
          this.isApproved =true;
        }
        
        this.capaType = this.capaTypes.find(x => x.key === v.capaEcType).text;
        this.breadcrumbs.push({
          title: `CAPA: ${v.capaTitle}`,
          path: '',
        });
      });
  }

  reloadEvidenceList(): Observable<TableDataEvidence<Evidence>> {
    return this.evidenceService.getEvidenceList(this.capaId)
      .pipe(
        tap(table => this.canAddEvidence = table.canAddEvidence)
      );
  }

  editEvidence(_id: number, data: Evidence): void {
    let copy;
    if (data) {
      copy = { ...data };
    }
    const dialogRef = this.dialog.open(EvidenceAddDialogComponent, { data: { evidence: copy, capaId: this.capaId } });

    dialogRef.afterClosed()
      .pipe(
        filter(res => res && res.success)
      )
      .subscribe(() => {        
        this.forceReloadEvent.emit(true);
      });
  }

  deleteData(id: number): Observable<RequestResult> {
    return this.evidenceService.deleteEvidence(id)
      .pipe(
        
      );
  }

  showAuditHistory(): void {
    this.router.navigateByUrl(`/capas/history/${this.capa.id}`);    
  } 

  editCapa(): void {
    const dialogRef = this.dialog.open(CapaEditDialogComponent, { data: { capa: this.capa } });

    dialogRef.afterClosed()
      .pipe(
        filter(res => res && res.success)
      )
      .subscribe(res => {
        this.capaService.getCapa(res.capaId)
          .subscribe(o => this.capa = o);
      });
  }
}
